var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "button-hover",
          attrs: { icon: "", disabled: _vm.disabledView },
          on: {
            click: function($event) {
              return _vm.$emit("remove")
            }
          }
        },
        [
          _c(
            "v-avatar",
            { attrs: { size: "25" } },
            [
              _vm.selectAll
                ? _c("img", {
                    attrs: {
                      src: _vm.selectAll.address
                        ? _vm.getCompanyImage(_vm.selectAll.id)
                        : _vm.getImageUrl(_vm.selectAll.id)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.selectAll
                ? _c("img", {
                    attrs: {
                      src: _vm.tasks.user_assignee_id
                        ? _vm.getImageUrl(_vm.tasks.user_assignee_id)
                        : _vm.getCompanyImage(_vm.tasks.company_id)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-icon",
                { attrs: { disabled: _vm.disabledView, size: "20" } },
                [_vm._v("delete")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2812eca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2812eca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Molecules/AssignmentTaskRemoveButton.vue
// module id = null
// module chunks = 